import React, { useContext, useEffect, useRef, useState } from 'react';
import { Badge, Box, Button, Grid, makeStyles, Paper } from '@material-ui/core';
import NotificationsActiveIcon from '@material-ui/icons/NotificationsActive';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import { truncateWithEllipsis, formatNumber } from '../../../helpers/common';
import UserContext from '../../../context/UserContext';

const useStyles = makeStyles(theme => ({
  card: {
    margin: 0,
    padding: theme.spacing(2),
    background: theme.palette.background.paper,
    width: '100%',
    '@media (max-width: 700px)': {
      padding: theme.spacing(0),
    },
  },
  titleContainer: {
    margin: theme.spacing(2, 0),
    padding: theme.spacing(2, 1),
    background: theme.palette.primary.main,
    color: '#fff',
    fontSize: 15,
    borderRadius: theme.spacing(0.5),
  },
  title: {
    fontWeight: 600,
    marginLeft: theme.spacing(2),
  },
  eventNumber: {
    background: theme.palette.primary.light,
    borderRadius: theme.spacing(0.5),
  },
  eventHeader: {
    color: 'white',
    background: theme.palette.primary.light,
    padding: theme.spacing(1),
    fontSize: 14,
    borderRadius: theme.spacing(0.5),
    marginTop: theme.spacing(1),
    textAlign: 'center',
  },
  eventBody: {
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
  },
  eventTime: {
    paddingLeft: theme.spacing(1),
  },
  eventTitle: {
    textTransform: 'uppercase',
    textAlign: 'center',
    fontWeight: 600,
    color: theme.palette.common.white,
  },
  eventDescription: {
    fontSize: 12,
  },
  singleCardContainer: {
    '@media (max-width: 700px)': {
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(1),
    },
  },
  singleCard: {
    minHeight: '100%',
    height: 'auto'
  },
}));

function EventsCard({ title, backPage, pageSizeBack }) {
  const classes = useStyles();
  const TABLEpAGE = 12;
  const [visibleItems, setVisibleItems] = useState(TABLEpAGE);
  const [lastPage, setLastPage] = useState(false);
  const { plan } = useContext(UserContext);


  // control por tarjeta
  const [expandedCards, setExpandedCards] = useState(new Set());

  const contentRefs = useRef([]);

  const [showSeeMore, setShowSeeMore] = useState({});

  const toggleCard = idx => {
    setExpandedCards(prev => {
      const next = new Set(prev);
      if (next.has(idx)) next.delete(idx);
      else next.add(idx);
      return next;
    });
  };

  const handleShowMore = () => {
    if (backPage.length <= visibleItems + TABLEpAGE) {
      setVisibleItems(() => backPage.length);
      setLastPage(true);
    } else {
      setVisibleItems(v => v + TABLEpAGE);
    }
  };

  useEffect(() => {
    // Medir la altura de cada card visible
    const newShowSeeMore = {};
    backPage.slice(0, visibleItems).forEach((ev, index) => {
      if (!ev.event.meter_name && !ev.event.meter) {
        const ref = contentRefs.current[index];
        if (ref) {
          newShowSeeMore[index] = ref.scrollHeight > 190;
        }
      }
    });
    setShowSeeMore(newShowSeeMore);
    // eslint-disable-next-line
  }, [backPage, visibleItems]);

  const getUnit = (key) => {
    let unit = plan?.sections["INSTANTANEOS"].filter(item => item.key === key)[0]?.base_unit;
    return unit
  }

  return (
    <Box justifyContent="center" className={classes.card}>
      <Box className={classes.titleContainer}>
        <Badge
          overlap="rectangular"
          badgeContent={`${backPage.length}`}
          color="secondary"
          max={pageSizeBack}
        >
          <NotificationsActiveIcon />
        </Badge>
        <span className={classes.title}>{title}</span>
      </Box>

      <Grid container spacing={2} alignItems='flex-start'>
        {backPage.slice(0, visibleItems).map((ev, index) => {
          const { event, date_formated } = ev;
          const {
            from_formated,
            to_formated,
            title,
            description,
            duration_str,
            meter_name,
            meter,
            event_detail,
            result,
          } = event;

          if (!meter_name && !meter) {
            const isExpanded = expandedCards.has(index);

            return (
              <Grid
                item
                xs={12}
                sm={6}
                md={4}
                lg={3}
                key={index}
                className={classes.singleCardContainer}
              >
                <Paper className={classes.singleCard} elevation={2}>
                  {/* Header */}
                  <div className={classes.eventHeader}>
                    <div className={classes.eventTitle}>{title}</div>

                    <div className={classes.eventDate}>{from_formated}</div>

                    <div className={classes.eventDate}>
                      Resultado:{' '}
                      <span
                        style={{
                          display: 'inline-block',
                          padding: '2px 8px',
                          borderRadius: 999,
                          fontWeight: 700,
                          fontSize: 12,
                          background: result
                            ? 'rgba(46, 204, 113, .12)'
                            : 'rgba(231, 76, 60, .12)',
                          color: result ? '#314b32' : '#c0392b'
                        }}
                        aria-label={`Resultado ${result ? 'positivo' : 'negativo'
                          }`}
                      >
                        {result ? 'Positivo' : 'Negativo'}
                      </span>
                    </div>
                  </div>

                  {/* Body */}
                  <div
                    className={classes.eventBody}
                    ref={el => (contentRefs.current[index] = el)}
                    style={
                      !isExpanded ? { maxHeight: 180, overflow: 'hidden' } : {}
                    }
                  >
                    {Array.isArray(event_detail) && event_detail.length > 0 ? (
                      event_detail.map((detail, dIdx) => {
                        const {
                          variable_name,
                          variable_operation,
                          result_number,
                          variable_key,
                          date,
                          nodes = [],
                        } = detail || {};

                        return (
                          <div
                            key={`detail-${dIdx}`}
                            style={{
                              border: '1px solid rgba(0,0,0,0.08)',
                              borderRadius: 8,
                              padding: 8,
                              marginBottom: 10,
                            }}
                          >
                            {/* Encabezado del detalle */}
                            <div
                              style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                gap: 8,
                                marginBottom: 6,
                              }}
                            >
                              <div style={{ fontWeight: 700 }}>
                                {variable_name || '—'}
                                {variable_operation ? (
                                  <span
                                    style={{
                                      fontWeight: 400,
                                      color: 'rgba(0,0,0,0.6)',
                                    }}
                                  >
                                    {' '}
                                    · {variable_operation}
                                  </span>
                                ) : null}
                              </div>
                            </div>

                            <div style={{ marginBottom: 6, marginTop: 6 }}>
                              {date}
                            </div>

                            {/* Datos del detalle */}
                            <div style={{ marginBottom: 6 }}>
                              Valor: <b>{result_number ? `${formatNumber(getUnit(variable_key), result_number)}` : '—'}</b>
                            </div>

                            {/* Nodes del detalle */}
                            {Array.isArray(nodes) && nodes.length > 0 ? (
                              <>
                                <div
                                  style={{
                                    marginBottom: 4
                                  }}
                                >
                                  Nodos vinculados:
                                </div>
                                <div
                                  style={{
                                    display: 'flex',
                                    flexWrap: 'wrap',
                                    gap: 6,
                                  }}
                                >
                                  {nodes.map((node, nIdx) => (
                                    <div
                                      key={`detail-${dIdx}-node-${nIdx}`}
                                      style={{
                                        border: '1px solid rgba(0,0,0,0.08)',
                                        borderRadius: 999,
                                        padding: '10px 20px',
                                        fontSize: 12,
                                        display: 'inline-flex',
                                        flexDirection: 'column',
                                        lineHeight: 1.2,
                                      }}
                                      title={`${node?.node_name || ''}`}
                                    >
                                      <span style={{ fontWeight: 700 }}>
                                        {node?.node_name ?? 'Nodo —'}
                                      </span>
                                      <span style={{ opacity: 0.8 }}>
                                        Llave: {node?.meter_key ?? '—'}
                                      </span>
                                    </div>
                                  ))}
                                </div>
                              </>
                            ) : (
                              <div
                                className={classes.eventTime}
                                style={{ color: 'rgba(0,0,0,0.45)' }}
                              >
                                Sin nodos asociados
                              </div>
                            )}
                          </div>
                        );
                      })
                    ) : (
                      <div
                        className={classes.eventTime}
                        style={{ color: 'rgba(0,0,0,0.45)' }}
                      >
                        Sin detalles para este evento
                      </div>
                    )}
                  </div>

                  {/* Toggle por tarjeta */}
                  {showSeeMore[index] && (
                    <Box
                      display="flex"
                      justifyContent="center"
                      alignItems="center"
                      borderTop="1px solid rgba(0,0,0,0.08)"
                      bgcolor="rgba(0,0,0,0.02)"
                      py={0.5}
                    >
                      <Button
                        size="small"
                        color="primary"
                        onClick={() => toggleCard(index)}
                        endIcon={
                          isExpanded ? <ExpandLessIcon /> : <ExpandMoreIcon />
                        }
                      >
                        {isExpanded ? 'Ver menos' : 'Ver más'}
                      </Button>
                    </Box>
                  )}
                </Paper>
              </Grid>
            );
          } else {
            return (
              <Grid
                item
                xs={12}
                sm={6}
                md={4}
                lg={3}
                key={index}
                className={classes.singleCardContainer}
              >
                <Paper className={classes.singleCard}>
                  <div className={classes.eventHeader}>
                    <div className={classes.eventTitle}>{`${title} ${event_detail ? 'de ' + event_detail : ''
                      }`}</div>
                    <div className={classes.eventDate}>
                      {truncateWithEllipsis(meter_name || meter, 30)}
                    </div>
                    <div className={classes.eventDate}> {date_formated}</div>
                  </div>
                  <div className={classes.eventBody}>
                    <div className={classes.eventTime}>
                      Inicio {from_formated}
                    </div>
                    {!description && (
                      <div className={classes.eventTime}>{to_formated}</div>
                    )}
                    {description && (
                      <div className={classes.eventTime}>{description}</div>
                    )}
                    {duration_str ? (
                      <div className={classes.eventTime}>
                        {' '}
                        Duración: {duration_str}
                      </div>
                    ) : null}
                  </div>
                </Paper>
              </Grid>
            );
          }
        })}
      </Grid>

      <Box align="center" mt={2}>
        <Button
          color="primary"
          variant="contained"
          onClick={handleShowMore}
          disabled={lastPage || backPage.length < TABLEpAGE}
        >
          Mostrar más...
        </Button>
      </Box>
    </Box>
  );
}

export default EventsCard;
